const helos = [
  {
    id: 30000,
    name: 'helo1',
    detail: 'Kiama Helo landing site',
    icon: 'helo',
    locationLatitude: -34.676892,
    locationLongitude: 150.85208,
  },
];

export default helos;



// WEBPACK FOOTER //
// ./src/fixtures/helos.js